/*
    Mixin for fetching prices for stock/etf
*/
import MarketData from './marketdata.js';

export const priceMixin = {
    data() {
        return {
            marketData: undefined,
            // marketDataPrices: undefined, // Now handled by vuex store
            observer: null,
            curResultsMapping: new Map(),
            resultsIndexMapping: new Map(),
            isGroups: false,
        }
    },
    methods: {
        /**
        * Sets up Intersection Observer API to tell when a user can see a row
        *
        * This needs to be called when user loads first time, loads more data, and sorts
        * @param {*} tableElementClass class selector for determining root of intersection observer
        * @param {*} rowElementClass class selector that intersection observer is looking for intersections
        * @param {*} isGroups Indicate whether we are tracking over multiple tables (groups)
        */
        initialized(tableElementClass, rowElementClass, isGroups) {
            //console.debug('Initializing Market Data');
            this.curResultsMapping.clear();
            // console.debug({tableElementClass}, {rowElementClass});
            if (!this.marketData) {
                this.marketData = new MarketData();
                this.marketData.startWebSocket(this.initialized.bind(null, tableElementClass, rowElementClass, isGroups), this.handleMessage);
                return;
            }

            this.isGroups = isGroups;

            // console.debug('Setting up observers');
            const options = {
                root: document.querySelector(tableElementClass),
                rootMargin: '0px',
                threshold: 0
            };

            const callback = (entries, observer) => this.handleIntersection(entries, observer);


            if (!this.isGroups) {
                if (this.observer) {
                    this.observer.disconnect();
                }
                //console.debug('setting up new observer...');
                this.observer = new IntersectionObserver(callback, options);
            } else {
                if (!this.observer) {
                    this.observer = new IntersectionObserver(callback, options);
                }
            }
            Vue.nextTick(() => {
                const tableRows = document.querySelectorAll(rowElementClass);
                //console.debug('Going through table', {tableRows});
                //console.debug({length: tableRows.length});
                // console.debug('Next tick...', {tableRows});
                // console.debug('row', document.querySelector(rowElementClass));
                for (let i = 0; i < tableRows.length; i++) {
                    //console.debug(tableRows);
                    //console.debug('Observing row...', i);
                    //console.debug('table row observing', tableRows[i]);
                    let item = tableRows[i].parentElement;
                    //console.debug('MKT CAP', item.children[6].innerHTML);
                    this.observer.observe(tableRows[i]);
                }
            });
        },
        /**
         * When a user can see a row, they subscribe to the market data feed
         * and once a value is gotten back & stored, display it.
         *
         * In instances like sort, value would already be stored & can be displayed
         * immediately.
         *
         * @param {IntersectionObserverEntry[]} entries List of entries that have just been seen & unseen
         * @param {IntersectionObserver} observer IntersectionObserver that triggered this
         */
        handleIntersection(entries, observer) {
            //console.debug("handleIntersection")

            if (this.isGroups) {
                if (this.resultsIndexMapping.size < 1) {
                    for (let i = 0; i < this.curResults.length; i++) {
                        for (let j = 0; j < this.curResults[i].length; j++) {
                            this.resultsIndexMapping.set(this.curResults[i][j].conid, {i, j});
                            //console.debug(this.curResults[i][j].conid, i, j);
                        }
                    }
                }
            } else {
                if (this.curResultsMapping.size < this.curResults.length) {
                    //console.debug('curResultsMapping setting...');
                    this.curResults.forEach((result, i) => {
                        this.curResultsMapping.set(result.conid, i);
                    });
                }
            }

            entries.forEach(entry => {
                const element = entry.target;
                const conid = element.dataset.conid;
                if (entry.isIntersecting) {
                    if (!this.marketDataPrices.get(parseInt(conid))) {
                        this.marketData.subscribe(conid);
                        //console.debug('Subbing to conid', conid);
                    } else {
                        //console.debug('Price already available...conid', conid);

                        let obj, group, index;
                        if (this.isGroups) {
                            [group, index] = this.resultsIndexMapping.get(conid.toString());
                            // console.debug(this.curResults, group, index);
                            obj = this.curResults[group][index];
                        // } else if (this.ids.length > 0) {
                        //     //console.debug(this.searchResults)
                        //     obj = this.searchResults.find(res => res.conid == conid);
                        //     index = this.searchResults.findIndex(res => res.conid == conid);
                        //     //console.debug("index", index, "obj", obj);
                        } else {
                            index = this.curResultsMapping.get(conid.toString());
                            obj = this.curResults[index];
                        }
                        if (obj.conv_price) {
                            //console.debug('Already have conv_price. Unobserve')
                            observer.unobserve(element);
                            return; // Already set
                        }
                        const _lastPrice = this.marketDataPrices.get(parseInt(conid));
                        obj.last_price = _lastPrice;
                        obj.contract_cur = obj.orig_currency;
                        obj.conv_price = _lastPrice;

                        if(this.isGroups) {
                            Vue.set(this.curResults[0], index, obj);
                        } else if (this.ids.length > 0) {
                            Vue.set(this.searchResults, index, obj);
                            console.log("vue set", this.searchResults, index, obj)
                        } else {
                            Vue.set(this.curResults, index, obj);
                        }
                    }
                }
            });
        },
        /**
        * Handles messages we get back from the WebSocket marketdata feed
        */
        handleMessage(e) {
            if (!this.marketData) {
                console.log("no marketdata")
                return;
            }
            // console.log("handleMessage", e);
            let data;
            try {
                data = JSON.parse(e);
            } catch (error) {
                // Syntax error. Couldn't parse message.
                return;
            }
            const conid = data.conid;
            const lastPrice = data['31'];
            // Ignore initialization method & unsubscribe & errors
            if (!conid || !lastPrice || lastPrice === '-1') {
                //console.debug("no conid or last price", conid, lastPrice);
                return;
            }

            // Already set.
            if (this.marketDataPrices.get(conid)) {
                return;
            }
            //console.debug('Got response back for ', conid);


            // Group Position & Index
            let posData, group, index, obj;
            if (this.isGroups) {
                posData = this.resultsIndexMapping.get(conid.toString());
                group = posData.i;
                index = posData.j;
                obj = this.curResults[group][index];
            // } else if (this.ids.length > 0) {
            //     console.debug(this.searchResults, conid)
            //     obj = this.searchResults.find(res => res.conid == conid);
            //     console.debug({obj})
            //     index = this.searchResults.findIndex(res => res.conid == conid);
            //     console.debug("index", index, "obj", obj);
            } else {
                index = this.curResultsMapping.get(conid.toString());
                obj = this.curResults[index];
                // console.debug('Obj Assigned', {index}, {obj});
            }

            if (!obj) {
                return;
            }

            let rate = 1;
            if (!(obj.orig_currency === obj.conv_currency)) {
                rate = this.currencyConversions.get(obj.orig_currency + '+' + obj.conv_currency);
                if (!rate) return; // We haven't gotten the rate request back yet.
            }

            this.marketData.unsubscribe(conid);
            this.marketDataPrices.set(conid, this.setExchPrice(lastPrice, rate));

            const _lastPrice = this.marketDataPrices.get(conid);
            // console.debug({_lastPrice});
            obj.last_price = _lastPrice;
            obj.contract_cur = obj.orig_currency;
            obj.conv_price = _lastPrice;
            if (this.isGroups) {
                Vue.set(this.curResults[group], index, obj);
                // console.debug('Set price for ', conid, _lastPrice, {group}, {index});
            // } else if (this.ids.length > 0) {
                // Vue.set(this.searchResults, index, obj);
                // console.debug('Set price for ', conid, _lastPrice, {index}, this.searchResults);
            } else {
                Vue.set(this.curResults, index, obj);
                // console.debug('Set price for ', conid, _lastPrice, {index});
            }
            // Get element that refers to this conid on the table
            const element = document.querySelector('[data-conid=\'' + conid + '\']');
            this.observer.unobserve(element);
        },
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.marketData) {
            this.marketData.closeWebSocket();
        }
    },
};
